import { Bank } from "src/models/bank.model";
import { axiosInstance } from "@/services/axiosInstance";

export const getBanks = async (
  page: number,
  pageSize: number
): Promise<{ data: Bank[]; totalPages: number }> => {
  const response = await axiosInstance.get(
    `/api/bank?page=${page}&pageSize=${pageSize}`
  );

  return {
    data: response.data.data,
    totalPages: response.data.totalPages,
  };
};

export const updateBank = async (
  id: string,
  bankData: Bank
): Promise<Response> => {
  const response = await axiosInstance.put(`/api/bank/${id}`, bankData);
  return response.data;
};

export const getBankById = async (
  id: string | undefined
): Promise<Bank | null> => {
  if (!id) return null;
  try {
    const response = await axiosInstance.get(`/api/bank/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Erro ao obter o produto ${id} :`, error);
    throw error;
  }
};

export const createBank = async (bankData: Partial<Bank>): Promise<Bank> => {
  const response = await axiosInstance.post("/api/bank", bankData);
  return response.data;
};

export const deleteBank = async (id: string): Promise<Response> => {
  const response = await axiosInstance.delete(`/api/bank/${id}`);
  return response.data;
};
